import { render, staticRenderFns } from "./FaultContent.vue?vue&type=template&id=047a7bc0&scoped=true&"
import script from "./FaultContent.vue?vue&type=script&lang=js&"
export * from "./FaultContent.vue?vue&type=script&lang=js&"
import style0 from "./FaultContent.vue?vue&type=style&index=0&id=047a7bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a7bc0",
  null
  
)

export default component.exports